import add from './add';
import withResolved from './with-resolved';

export default function updateFactory({
  query,
  deriveQueryArgs,
  update,
  form,
  redirectTo,
}) {
  return withResolved({ query, deriveQueryArgs, as: 'default' })(
    add({ update, form, redirectTo }),
  );
}
